export const maskAccountNumber = (number: string) => {
  return number.replace(/\d(?=\d{4})/g, '*')
}
